import { Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { Filters } from './components/Filters';

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  return (
    <VStack
      space={Utils.Responsive.All({
        desktop: 'stack.xxs',
        tablet: 'stack.xxxs',
        phone: 'stack.xxxs',
      })}
      zIndex={10}
      p={Utils.Responsive.All({
        desktop: 'inset.xs',
        tablet: 'inset.sm',
        phone: 0,
      })}
      pb={0}>
      <Text fontWeight="bold" color="neutral.darkest">
        Solicitações
      </Text>
      <Filters />
    </VStack>
  );
};
